module.exports = __webpack_public_path__ + "static/media/learn-german-dw.3b0d1d7b.jpg";